import { Form } from "antd"
import BaseModal from "../../../components/layout/BaseModal"
import BaseSectionHeadline from "../../../components/elements/BaseSectionHeadline"
import BaseInputField from "../../../components/elements/BaseInputField"
import BaseSelection from "../../../components/elements/BaseSelection"
import { useEffect, useRef, useState } from "react"
import BaseInputSelection from "../../../components/elements/BaseInputSelection"
import { RefreshCcw, X } from "lucide-react"
import SignatureCanvas from "react-signature-canvas"
import { getEmployeeNamesOnly } from "../../Mitarbeiter/api/apiCalls"
import { GeneralQueryKeys } from "../../../api/constants"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { InputObject } from "../../../components/types"
import { useCreateKeyMutation, useUpdateKeyMutation } from "../api/services"
import { KeycollectionType } from "../../Objekte/types/types"
import dayjs from "dayjs"

type AddKeyCollectionModalType = {
    modalId: number
    closeModal: () => void
    selectedKey: KeycollectionType | null
}

export default function AddKeyCollectionModal(props: AddKeyCollectionModalType) {
    const [currentOwnerState, setCurrentOwnerState] = useState<string>()
    const [signature, setSignature] = useState<boolean>(false)
    const [form] = Form.useForm()
    const signatureRef = useRef<any>("")

    const { data: employees } = useQuery({
        queryKey: [GeneralQueryKeys.EMPLOYEE_NAMES_ONLY],
        queryFn: () => getEmployeeNamesOnly(),
    })

    // handle save keycollection
    const queryClient = useQueryClient()
    const { mutate: addKeycollection } = useCreateKeyMutation(queryClient, GeneralQueryKeys.KEYS_ALL)
    const handleAddKeycollection = () => {
        form.validateFields().then(() => {
            console.log({
                body: { ...form.getFieldsValue(), signature: signatureRef.current.toDataURL() },
            })
            addKeycollection({
                body: { ...form.getFieldsValue(), signature: signatureRef.current.toDataURL() },
            })
            // form.resetFields()
            // props.closeModal()
        })
    }

    const { mutate: updateKey } = useUpdateKeyMutation(queryClient, GeneralQueryKeys.KEYS_ALL)
    const handleUpdateKeycollection = () => {
        form.validateFields().then(() => {
            // console.log({
            //     body: { ...form.getFieldsValue(), signature: signatureRef.current.toDataURL() },
            // })
            updateKey({
                body: { ...form.getFieldsValue(), signature: signatureRef?.current?.toDataURL() ? signatureRef.current.toDataURL() : undefined },
                id: props.selectedKey?._id as string,
            })
        })
    }
    useEffect(() => {
        if (props.selectedKey) {
            console.log(props.selectedKey)
            form.setFieldsValue(props.selectedKey)
            if (props.selectedKey.currentOwner === "Hausverwaltung" || props.selectedKey.currentOwner === "Mieter" || props.selectedKey.currentOwner === "Büro") {
                setCurrentOwnerState("extern")
                form.setFieldsValue({ currentOwnerState: "extern" })
            } else {
                setCurrentOwnerState("intern")
                form.setFieldsValue({ currentOwnerState: "intern" })
            }
            setSignature(props.selectedKey.signature ? true : false)
        }
    }, [props.selectedKey])

    return (
        <BaseModal
            title={`Schlüsselbund ${props.selectedKey ? "bearbeiten" : "hinzufügen"}`}
            modalId={props.modalId}
            bottomRow={
                <div className="flex justify-end">
                    <button className="btn btn-primary" onClick={() => form.submit()}>
                        Speichern
                    </button>
                </div>
            }>
            <Form form={form} onFinish={props.selectedKey ? handleUpdateKeycollection : handleAddKeycollection}>
                <div className="grid gap-x-4 pt-4">
                    <Form.Item name="name" className="!mb-2" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        <BaseInputField type="text" label="Name" onChange={() => {}} />
                    </Form.Item>
                    <Form.Item name="keyCount" className="!mb-2" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        <BaseInputField type="text" label="Anzahl" onChange={() => {}} />
                    </Form.Item>
                    <Form.Item name="keys" className="!mb-2" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        <BaseInputField type="text" label="Schlüssel" onChange={() => {}} />
                    </Form.Item>
                    <Form.Item name="currentOwnerState" className="!mb-2" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        <BaseSelection
                            label="Benutzer"
                            placeholder="Benutzerklasse auswählen"
                            data={["intern", "extern"]}
                            setId={(e) => {
                                setCurrentOwnerState(e)
                                form.resetFields(["currentOwner"])
                                form.setFieldsValue({ currentOwnerState: e })
                            }}
                        />
                    </Form.Item>
                    <Form.Item name="currentOwner" className="!mb-2" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        {currentOwnerState === "extern" ? (
                            <BaseSelection
                                label="Benutzer"
                                placeholder="Benutzer auswählen"
                                data={["Hausverwaltung", "Mieter", "Büro"]}
                                setId={(e) => {
                                    form.setFieldsValue({ currentOwner: e })
                                }}
                            />
                        ) : (
                            <BaseInputSelection
                                label="Benutzer"
                                placeholder="Benutzer auswählen"
                                data={employees as InputObject[]}
                                disabled={employees?.length === 0 || !employees}
                                setId={(e) => {
                                    form.setFieldsValue({ currentOwner: e })
                                }}
                            />
                        )}
                    </Form.Item>
                </div>
                <div className="flex flex-col gap-4 mt-4 w-full justify-center items-center">
                    <BaseSectionHeadline
                        label="Unterschrift"
                        icon={
                            signature ? (
                                <RefreshCcw className="cursor-pointer w-5 h-5" onClick={() => setSignature(false)} />
                            ) : (
                                <X className="cursor-pointer w-5 h-5" onClick={() => setSignature(true)} />
                            )
                        }
                    />
                    <div className="h-full ">
                        {props.selectedKey?.signature && signature ? (
                            <img src={props.selectedKey?.signature} alt="Unterschrift" className="w-[300px] h-[200px] object-cover" />
                        ) : (
                            <SignatureCanvas ref={signatureRef} canvasProps={{ width: window.innerWidth * 0.9, height: window.innerWidth * 0.5, className: "signature-canvas border rounded-default" }} />
                        )}
                    </div>
                </div>
                {props.selectedKey && (
                    <div className="flex flex-col gap-1 mt-2 w-full">
                        <BaseSectionHeadline label="History" />

                        {props.selectedKey?.history?.map((history: any) => (
                            <div className="flex flex-col mt-1" key={history.timestamp}>
                                <p className="text-sm text-gray-400">
                                    {dayjs(history.timestamp).format("DD.MM.YYYY")} um {dayjs(history.timestamp).format("HH:mm")} Uhr
                                </p>
                                <p className="font-medium text-sm tracking-tight leading-4">{history.change}</p>
                            </div>
                        ))}
                    </div>
                )}
            </Form>
        </BaseModal>
    )
}
